export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8050.159d7c6e.jpg";